import {Environment} from '@tisa-group/cdk/models';

export const environment: Environment = {
  context: 'staging',
  name: 'ekstraklasa',
  production: true,
  productsUrls: {
    auth: 'https://staging--ekstraklasa-auth.netlify.app',
    umpire: 'https://staging--ekstraklasa-umpire.netlify.app',
    gateway: 'https://staging--ekstraklasa-gateway.netlify.app',
    wicket: 'https://staging--ekstraklasa-wicket.netlify.app',
    'wicket-admin': 'https://staging--ekstraklasa-wicket-admin.netlify.app',
    'umpire-ott-client':
      'https://staging--ekstraklasa-umpire-ott-client-admin.netlify.app',
    'umpire-ott-tizen-client':
      'https://staging--ekstraklasa-umpire-ott-tizen-client-admin.netlify.app',
    'umpire-client': 'https://staging--ekstraklasa-umpire-client-admin.netlify.app',
  },
  config: {},
  clientConfig: {
    apiUrls: {
      wicketProfileUrl: 'https://ekstraklasa.wicket-test.sso-tisa.com/p',
      wicketDictionariesUrl: 'https://ekstraklasa.wicket-test.sso-tisa.com/d',
      wicketV2: 'https://ekstraklasa.wicket-test.sso-tisa.com/api/v2',
      wicketEntitlements: 'https://ekstraklasa.wicket-test.sso-tisa.com/entitlements/api',
      wicketAssets:
        'https://s3.eu-central-1.amazonaws.com/wicket-upload-ekstraklasa-test',
      umpire: 'https://stage-umpire-api.ekstraklasa-tv.tisagroup.ch/api/v3',
    },
    myCujooPublicKey: 'K8IS91R64HUMD85634D7QEJ8S5BUN7OM',
    wicket: {
      'application-sub': 'K8BmaF1MI2e6FXpYltfWmyp30ZmmdLZTcZL7PyGW68Kliwr3rw',
      'chargebee-site': 'ekstraklasa-test',
      'chargebee-item-familly-id': 'develop_ekstraklasa_tv',
    },
    umpire: {
      apiKey: '20546ddbd77ccf60782a3c2a573418f4',
      mobileApiKey: 'eef3bf18580e7728da05babd95dd2d54',
      cloudFrontId: 'd209nx4b7slfz4',
    },
    facebook: {appId: '639104087127812'},
    bradmaxClientToken: 'GY0Ur_3IQoxOmUI_GIBmxx-Qh4LoB_WIqmBxZQ',
    mobileApps: {
      apple: 'https://apps.apple.com/app/ekstraklasa-tv/id917269036',
      android: 'https://play.google.com/store/apps/details?id=com.oz.eon.ekstraklasa',
    },
    socialMedia: {
      facebook: 'https://facebook.com/Ekstraklasa.org',
      instagram: 'https://instagram.com/ekstraklasa_official',
      youtube: 'https://youtube.com/channel/UCdQmcmHM_sbhDvgKvzizOaQ',
      x: 'https://twitter.com/_Ekstraklasa_',
    },
    templatePagesSlugsBlockedByCountry: ['live'],
    views: {showStandings: true, showClubs: true, showOffer: true},
    languages: ['pl', 'en'],
    googleAdsClientId: 'ca-pub-7617933467799224',
  },
};
